import { PageService } from './page.service';

export class Page {
  public uid: any;
  public subject: string;
  public content: string = "";
  public chapter: string = "";
  
  //public constructor(init?:Partial<Page>) {
  //  Object.assign(this, init);
  //}
    
  public constructor(
	fields?: {
		uid?: any, 
		subject?: string,
		content?: string
	}) 
  {
        if (fields) {
			this.uid = fields.uid || "0";
			this.subject = fields.subject || "";
			this.content = fields.content || "";
		}
  }
  
  public getSubjectStripped(): string {
	  var regex = /(\[.*\])/; 
	  
	  if(this.subject == null) return '';
	  
	  //console.log(this.subject);
	  
	  return this.subject.replace(regex, '');
  }
  
}
